export default "__VITE_ASSET__oYFyNbq4__"